module.exports = __webpack_public_path__ + "media/content-creator/mobile-pets-2-8ab561c3.png";